import { Injectable } from '@angular/core';
import { MetaDataService } from './meta-data.service';

declare global {
  interface Window {
    initMap: () => void;
  }
}

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {
  private scriptLoaded = false;
  public mapId: string = '';
  public apiKey: string = '';

  constructor(private metaDataService: MetaDataService) {

  }

  loadScript(apiKey: string, mapId: string): Promise<void> {
    this.apiKey = apiKey;
    this.mapId = mapId;
    if (this.scriptLoaded) {
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,visualization&map_ids=${mapId}&callback=initMap&loading=async&v=weekly`;
      script.async = true;
      script.defer = true;
      
      
      window.initMap = () => {
        this.scriptLoaded = true;
        resolve();
      };
      
      script.onerror = () => reject('Failed to load Google Maps script');
      document.head.appendChild(script);
    });
  }

  getEventLocationCoordinates(): google.maps.LatLngLiteral {
    const latitude = this.metaDataService.latitude;
    const longitude = this.metaDataService.longitude;
    
    return latitude !== null && longitude !== null ? { lat: latitude, lng: longitude } : { lat: 18.5204, lng: 73.8567 };
  }
}
